import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import Cookies from "js-cookie";
import { Button, Checkbox, CheckboxChangeEvent, Select, Spin, } from "antd";
import { CloseCircleOutlined, CloseOutlined } from "@ant-design/icons";
import { all_routes } from "../../../../router/all_routes";
import { useUserPermissions } from "../../../../UserPermissionsContext";
import Table from "../../../../../core/common/dataTable/index";
import { format } from "date-fns";
import { Calendar } from "react-date-range";
import { BiRefresh } from "react-icons/bi";
type Permission = { id: number; name: string };
type Admin = {
  id: number;
  branch_name: string;
  is_wizklub: boolean;
  is_offline: boolean;
  branch: number;
  building_category_name: string;
};

type Agent = {
  id: number;
  username: string;
};

type State = {
  state_id: number,
  name: string,
  label: string,
}
type Zone = {
  zone_id: number,
  name: string,
  label: string,
}

type Branch = {
  branch_id: number,
  name: string,
  label: string,
}

type BuludingCategory = {
  building_category_id: number,
  name: string,
}


const { Option } = Select;

const ScoreReports = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
  const day = String(today.getDate()).padStart(2, "0");
  const formattedDate = `${month}-${day}-${year}`;
  const defaultValue = dayjs(formattedDate);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [admin, setAdmin] = useState<Admin[]>([]);
  const [from, setFrom] = useState();
  const [to, setTo] = useState<number>();
  const [totalCount, setTotalCount] = useState();
  const [toastMessage, setToastMessage] = useState("");
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [searchText, setSearchText] = useState<string>("");
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
  const [AsignshowCard, setAsignShowCard] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState<string[]>([]);
  const [agentsLoading, setAgentsLoading] = useState(false);
  const [agentsDropdown, setAgentsDropdown] = useState<Agent[]>([]);
  const [dangerToastMessage, setDangerToastMessage] = useState("");
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
  const [states, setStates] = useState<State[]>([]);
  const [zones, setZones] = useState<Zone[]>([]);
  const [branches, setBranches] = useState<Branch[]>([]);
  const [buildingCategories, setBuildingCategories] = useState<BuludingCategory[]>([]);
  const [ticketCategories, setTicketCategories] = useState<any[]>([]);
  const [ticketSubCategories, setTicketSubCategories] = useState<any[]>([]);

  const [selectedBuildingCategory, setSelectedBuildingCategory] = useState<number>(() => {
    return Number(localStorage.getItem("selectedBuildingCategory")) || 0;
  });

  const [selectedState, setSelectedState] = useState<number>(() => {
    return Number(localStorage.getItem("selectedState")) || 0;
  });

  const [selectedTicketCategory, setSelectedTicketCategory] = useState<number>(() => {
    return Number(localStorage.getItem("selectedTicketCategory")) || 0;
  });

  const [selectedTicketSubCategory, setSelectedTicketSubCategory] = useState<number>(() => {
    return Number(localStorage.getItem("selectedTicketSubCategory")) || 0;
  });

  const [selectedAgentFilter, setSelectedAgentFilter] = useState<number>(() => {
    return Number(localStorage.getItem("selectedAgentFilter")) || 0;
  });

  const [selectedZone, setSelectedZone] = useState<number>(() => {
    return Number(localStorage.getItem("selectedZone")) || 0;
  });

  const [selectedBranch, setSelectedBranch] = useState<number>(() => {
    return Number(localStorage.getItem("selectedBranch")) || 0;
  });
  // const [selectedAgentFilter, setSelectedAgentFilter] = useState<number>(0);
  const handleClearState = () => setSelectedState(0);
  const handleClearZone = () => setSelectedZone(0);
  const handleClearBranch = () => setSelectedBranch(0);
  const handleBuildingCategory = () => setSelectedBuildingCategory(0);
  const handleClearTicketCategoryChange = () => { setSelectedTicketCategory(0); setSelectedTicketSubCategory(0); setTicketSubCategories([]) }
  const handleClearTicetSubCategoryChange = () => setSelectedTicketSubCategory(0);
  const handleClearAgentChange = () => setSelectedAgentFilter(0);
  const [selectedDate, setSelectedDate] = useState(() => {
    const savedDate = localStorage.getItem("ScoreBranchDateForEmployee");
    return savedDate ? new Date(savedDate) : new Date(); // default is today
  });
  const [showCalendar1, setShowCalendar1] = useState(false);
  useEffect(() => {
    localStorage.setItem("selectedState", selectedState.toString());
  }, [selectedState]);

  useEffect(() => {
    localStorage.setItem("selectedZone", selectedZone.toString());
  }, [selectedZone]);

  useEffect(() => {
    localStorage.setItem("selectedBranch", selectedBranch.toString());
  }, [selectedBranch]);
  useEffect(() => {
    localStorage.setItem("selectedBuildingCategory", selectedBuildingCategory.toString());
  }, [selectedBuildingCategory]);
  useEffect(() => {
    localStorage.setItem("selectedTicketCategory", selectedTicketCategory.toString());
  }, [selectedTicketCategory]);
  useEffect(() => {
    localStorage.setItem("selectedTicketSubCategory", selectedTicketSubCategory.toString());
  }, [selectedTicketSubCategory]);
  useEffect(() => {
    localStorage.setItem("selectedAgentFilter", selectedAgentFilter.toString());
  }, [selectedAgentFilter]);

  useEffect(() => {
    if (selectedDate) {
      const formatted = format(selectedDate, "yyyy-MM-dd"); // 👉 Ensures '2025-07-14'
      localStorage.setItem("ScoreBranchDateForEmployee", formatted);
      setShowCalendar1(false);
    } else {
      localStorage.removeItem("ScoreBranchDateForEmployee");
    }
  }, [selectedDate]);

  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  useEffect(() => {
    if (!checkPermission("view_scorebranchcallingagentsreports", "scorebranchcallingagentsreports")) {
      navigate(routes.adminDashboard);
    } else {
      fetchData(currentPage, pageSize, searchText, selectedState, selectedZone, selectedBranch, selectedAgentFilter);
      fetchBuildingCategories();
      fetchStates();
      fetchZones();
      fetchBranches();
      fetchTicketCategories();
      fetchAgents();
    }
  }, [userPermissions]);

  useEffect(() => {
    fetchData(currentPage, pageSize, searchText, selectedState, selectedZone, selectedBranch, selectedAgentFilter);
    fetchZones();
    fetchBranches();
  }, [selectedState, selectedZone, selectedBranch, searchText, currentPage, pageSize, selectedAgentFilter, selectedBuildingCategory, selectedDate, selectedTicketCategory, selectedTicketSubCategory])


  useEffect(() => {
    if (selectedTicketCategory) {
      fetchTicketSubCategories();
    }
  }, [selectedTicketCategory])
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  const fetchTicketCategories = async () => {

    try {
      const response = await fetch(
        `${webApi}/score/score_catgory_dropdown/`,
        options
      );
      const data = await response.json();
      setTicketCategories(data);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    } finally {

    }
  };

  const fetchTicketSubCategories = async () => {

    try {
      const response = await fetch(
        `${webApi}/employees/teacher_ticket_subcategory_dropdown/${selectedTicketCategory}/`,
        options
      );
      const data = await response.json();
      setTicketSubCategories(data);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    } finally {

    }
  };



  const fetchAgents = async () => {

    try {
      const response = await fetch(
        `${webApi}/employees/employee_team_members_dropdown/`,
        options
      );
      const data = await response.json();
      setAgentsDropdown(data);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    } finally {

    }
  };

  const fetchBuildingCategories = async () => {

    try {
      const response = await fetch(
        `${webApi}/branches/building_category_dropdown/`,
        options
      );
      const data = await response.json();
      setBuildingCategories(data);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    } finally {

    }
  };
  const [refreshIsLoading, setRefreshIsLoading] = useState(false);
  const fetchSlotsRefresh = async () => {
    try {
      setRefreshIsLoading(true);
      const formattedDate = selectedDate ? format(selectedDate, 'yyyy-MM-dd') : '';
      const response = await fetch(

        `${webApi}/score/update_call_logs_in_score_exam_calling_report/?exam_date=${formattedDate}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({
            exam_date: formattedDate
          }),
        }
      );

      const data = await response.json();

      if (data.status === "success") {
      } else {
        console.error("Sync failed:", data.message);
      }
    } catch (error) {
      console.error("Error syncing attendance:", error);
    } finally {
      fetchData(currentPage, pageSize, searchText, selectedState, selectedZone, selectedBranch, selectedAgentFilter);
      setRefreshIsLoading(false);
    }
  };

  const fetchStates = async () => {
    try {
      let apiUrl = `${webApi}/score/score_state_dropdown/`;
      if (selectedBuildingCategory) apiUrl += `?building_category_ids=${selectedBuildingCategory}`;
      const response = await fetch(
        apiUrl,
        options
      );
      const data = await response.json();
      setStates(data);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    }
  }

  const fetchZones = async () => {
    try {
      let apiUrl = `${webApi}/score/score_zones_dropdown/`;
      if (selectedBuildingCategory) apiUrl += `?building_category_ids=${selectedBuildingCategory}`;
      if (selectedState) apiUrl += selectedBuildingCategory ? `&state_ids=${selectedState}` : `?state_ids=${selectedState}`;
      const response = await fetch(
        apiUrl,
        options
      );
      const data = await response.json();
      setZones(data.results);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    }
  }

  const fetchBranches = async () => {
    let apiUrl = `${webApi}/score/score_employee_branches_dropdown/`;
    if (selectedBuildingCategory) apiUrl += `?building_category_ids=${selectedBuildingCategory}`;
    if (selectedState) apiUrl += selectedBuildingCategory ? `&state_ids=${selectedState}` : `?state_ids=${selectedState}`;
    if (selectedZone) apiUrl += (selectedBuildingCategory || selectedState) ? `&zone_ids=${selectedZone}` : `?zone_ids=${selectedZone}`;
    try {
      const response = await fetch(
        apiUrl,
        options
      );
      const data = await response.json();
      setBranches(data.results);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    }
  }



  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchGroupsData = async (
    page: number,
    pageSize: number,
    searchText: string,
    state?: number,
    zone?: number,
    branch?: number,
    agent?: number,
  ) => {
    const formattedDate = selectedDate ? format(selectedDate, 'yyyy-MM-dd') : '';
    let apiUrl = `${webApi}/score/score_branch_calling_agents_reports/?page=${page}&page_size=${pageSize}&exam_date=${formattedDate}`;
    if (searchText) apiUrl += `&search=${searchText}`;
    if (state) apiUrl += `&state=${state}`;
    if (zone) apiUrl += `&zone=${zone}`;
    if (branch) apiUrl += `&branch=${branch}`;
    if (agent) apiUrl += `&agent=${agent}`;
    if (selectedBuildingCategory) apiUrl += `&building_category=${selectedBuildingCategory}`;
    if (selectedTicketCategory) apiUrl += `&teacher_ticket__category=${selectedTicketCategory}`;
    if (selectedTicketSubCategory) apiUrl += `&teacher_ticket__subcategory=${selectedTicketSubCategory}`;
    const response = await fetch(apiUrl,
      options
    );
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/login");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    return await response.json();
  };

  const fetchData = async (
    page: number,
    pageSize: number,
    searchText: string,
    state?: number,
    zone?: number,
    branch?: number,
    agent?: number,
  ) => {
    setIsLoading(true); // Start loading
    try {
      const [groupsData] = await Promise.all([
        fetchGroupsData(page, pageSize, searchText, state, zone, branch, agent),
      ]);
      setTotalPages(groupsData.total_pages);
      setAdmin(groupsData.results);
      setTotalCount(groupsData.total_count);
      setFrom(groupsData.from);
      setTo(groupsData.to);
      setTotalCount(groupsData.total_count);
      setToastMessage(groupsData.message || "submitted successfully!");
      setShowSuccessToast(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  const handleTableChange = (pagination: any) => {
    const { current, pageSize } = pagination;
    setCurrentPage(current);
    setPageSize(pageSize);
    // fetchData(current, pageSize, searchText, selectedState, selectedZone, selectedBranch); // Fetch new data based on the updated pagination
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    // fetchData(currentPage, pageSize, value, selectedState, selectedZone, selectedBranch);
  };

  const updateBranchDetails = async (
    id: any,
    updateData: { [x: number]: any }
  ) => {
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(updateData),
    };
    const url = `${webApi}/branches/branch_details/${id}/`;
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error("Network response was not ok");
    }
  };

  const handleCheckboxChange = async (
    id: any,
    field: string,
    value: boolean
  ) => {
    const updateData = { [field]: value };
    try {
      await updateBranchDetails(id, updateData);
      await fetchData(currentPage, pageSize, searchText, selectedState, selectedZone, selectedBranch, selectedAgentFilter);
    } catch (error) {
      console.error("Error updating branch details:", error);
    }
  };

  const handleSelect = (
    student_id: any,
    selectedRowKeys: string[],
    setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    const selectedIds = [...selectedRowKeys];
    const index = selectedIds.indexOf(student_id);
    if (index >= 0) {
      selectedIds.splice(index, 1);
    } else {
      selectedIds.push(student_id);
    }
    setSelectedRowKeys(selectedIds);
  };

  const handleSelectAll = (
    e: CheckboxChangeEvent,
    data: { id: any }[],
    setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    if (e.target.checked) {
      const allIds = data.map((item) => item.id);
      setSelectedRowKeys(allIds);
    } else {
      setSelectedRowKeys([]);
    }
  };

  const handleAgentAssignment = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setAgentsLoading(true);
    try {
      const response = await fetch(
        `${webApi}/branches/assign_summercamp_agents_to_branches/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({
            branch_ids: selectedRowKeys,
            leader_id: selectedAgent,
            // target_date_: targetDate,
          }),
        }
      );

      const data = await response.json();
      if (!response.ok) {
        setDangerToastMessage(data.message);
        setShowSolidDangerToast(true);
        throw new Error("Failed to assign agent");
      }

      console.log("Agent assigned successfully", data);
      setToastMessage(data.message);
      setshowSolidSuccessToast(true);
      setSelectedRowKeys([]);
      setSelectedAgent([]);
      // setTargetDate("");
      setAsignShowCard(false);
      fetchData(
        currentPage,
        pageSize,
        searchText,
        selectedState, selectedZone, selectedBranch, selectedAgentFilter
      );
    } catch (error) {
      console.error("Failed to assign agent", error);
    } finally {
      setAgentsLoading(false);
    }
  };

  const handleSelectChange = (value: string[]) => {
    setSelectedAgent(value);
  };

  const handleExportClick = () => {
    const formattedDate = selectedDate ? format(selectedDate, 'yyyy-MM-dd') : '';
    let url = `${webApi}/score/export_score_exam_branch_calling_reports/?exam_date=${formattedDate}&token=${jwtToken}&search=${searchText}`;

    // Add orientation only if not 0
    if (selectedBuildingCategory !== 0) {
      url += `&building_category=${selectedBuildingCategory}`;
    }

    // Add previous_orientation only if not 0
    if (selectedState !== 0) {
      url += `&state=${selectedState}`;
    }

    if (selectedZone !== 0) {
      url += `&zone=${selectedZone}`;
    }

    if (selectedBranch !== 0) {
      url += `&branch=${selectedBranch}`;
    }

    if (selectedTicketCategory !== 0) {
      url += `&teacher_ticket__category=${selectedTicketCategory}`;
    }

    if (selectedTicketSubCategory !== 0) {
      url += `&teacher_ticket__subcategory=${selectedTicketSubCategory}`;
    }

    if (selectedAgentFilter !== 0) {
      url += `&agent=${selectedAgentFilter}`;
    }

    window.location.href = url;
  };

  const columns = [
    // {
    //   title: "Action",
    //   dataIndex: "action",
    //   render: (_text: any, record: { id: any }) => (
    //     <Checkbox
    //       checked={selectedRowKeys.includes(record.id)}
    //       onChange={() =>
    //         handleSelect(record.id, selectedRowKeys, setSelectedRowKeys)
    //       }
    //     />
    //   ),
    //   key: "action",
    //   // align: "center",
    // },
    {
      title: (
        <span>
          Building Category{selectedBuildingCategory !== 0 ? ` (${buildingCategories.find(state => state.building_category_id === selectedBuildingCategory)?.name})` : ""}
          {selectedBuildingCategory !== 0 && (
            <CloseCircleOutlined
              onClick={handleBuildingCategory}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>

      ),
      dataIndex: "building_category_name",
      key: "building_category_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Building Category"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = buildingCategories.find((s) => s.building_category_id === value);
              setSelectedKeys(selected ? [selected.name] : []);
              setSelectedBuildingCategory(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
            }
          >
            {buildingCategories.map((state) => (
              <Select.Option key={state.building_category_id} value={state.building_category_id}>
                {state.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { state_name: string }) => record.state_name === value,

    },
    {
      title: (
        <span>
          State{selectedState !== 0 ? ` (${states.find(state => state.state_id === selectedState)?.name})` : ""}
          {selectedState !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearState}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>

      ),
      dataIndex: "state_name",
      key: "state_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select State"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = states.find((s) => s.state_id === value);
              setSelectedKeys(selected ? [selected.name] : []);
              setSelectedState(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
            }
          >
            {states.map((state) => (
              <Select.Option key={state.state_id} value={state.state_id}>
                {state.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { state_name: string }) => record.state_name === value,

    },
    {
      title: (
        <span>
          Zone{selectedZone !== 0 ? ` (${zones.find(zone => zone.zone_id === selectedZone)?.name})` : ""}
          {selectedZone !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearZone}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>

      ),
      dataIndex: "zone_name",
      key: "zone_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Zone"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = zones.find((z) => z.zone_id === value);
              setSelectedKeys(selected ? [selected.name] : []);
              setSelectedZone(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
            }
          >
            {zones.map((zone) => (
              <Select.Option key={zone.zone_id} value={zone.zone_id}>
                {zone.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { zone_name: string }) => record.zone_name === value,

    },
    {
      title: (
        <span>
          Branch{selectedBranch !== 0 ? ` (${branches.find(branch => branch.branch_id === selectedBranch)?.name})` : ""}
          {selectedBranch !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearBranch}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>

      ),
      dataIndex: "branch_name",
      key: "branch_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Branch"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = branches.find((b) => b.branch_id === value);
              setSelectedKeys(selected ? [selected.name] : []);
              setSelectedBranch(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
            }
          >
            {branches.map((branch) => (
              <Select.Option key={branch.branch_id} value={branch.branch_id}>
                {branch.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { branch_name: string }) => record.branch_name === value,

    },
    {
      title: (
        <span>
          Category {selectedTicketCategory !== 0 ? ` (${ticketCategories.find(branch => branch.category_id === selectedTicketCategory)?.category_name})` : ""}
          {selectedTicketCategory !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearTicketCategoryChange}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>

      ),
      dataIndex: "category_name",
      key: "category_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Branch"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = ticketCategories.find((b) => b.category_id === value);
              setSelectedKeys(selected ? [selected.name] : []);
              setSelectedTicketCategory(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
            }
          >
            {ticketCategories.map((branch) => (
              <Select.Option key={branch.category_id} value={branch.category_id}>
                {branch.category_name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { category_name: string }) => record.category_name === value,

    },
    {
      title: (
        <span>
          Sub Category{selectedTicketSubCategory !== 0 ? ` (${ticketSubCategories.find(branch => branch.subcategory_id === selectedTicketSubCategory)?.subcategory_name})` : ""}
          {selectedTicketSubCategory !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearTicetSubCategoryChange}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>

      ),
      dataIndex: "sub_category_name",
      key: "sub_category_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Sub Category"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = ticketSubCategories.find((b) => b.subcategory_id === value);
              setSelectedKeys(selected ? [selected.name] : []);
              setSelectedTicketSubCategory(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
            }
          >
            {ticketSubCategories.map((branch) => (
              <Select.Option key={branch.subcategory_id} value={branch.subcategory_id}>
                {branch.subcategory_name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { branch_name: string }) => record.branch_name === value,

    },
    {
      title: (
        <span>
          Agent{selectedAgentFilter !== 0 ? ` (${agentsDropdown.find(branch => branch.id === selectedAgentFilter)?.username})` : ""}
          {selectedAgentFilter !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearAgentChange}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>

      ),
      dataIndex: "agent_name",
      key: "agent_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Agent"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = agentsDropdown.find((b) => b.id === value);
              setSelectedKeys(selected ? [selected.username] : []);
              setSelectedAgentFilter(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
            }
          >
            {agentsDropdown.map((branch) => (
              <Select.Option key={branch.id} value={branch.id}>
                {branch.username}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { branch_name: string }) => record.branch_name === value,

    },
    {
      title: "Call Status",
      dataIndex: "call_status"
    },
    // {
    //   title: "Call Logs(Refresh)",
    //   key: "refresh",
    //   render: (_: any, record: { branch: number }) => (
    //     <BiRefresh
    //       className={`refresh-icon ${refreshIsLoading ? "spin" : ""}`}
    //       onClick={() => fetchSlotsRefresh()}
    //       style={{ cursor: "pointer", fontSize: "28px" }}
    //     />
    //   ),
    // },

    // {
    //    title: (
    //     <span>
    //       Agent{selectedAgentFilter !== 0 ? ` (${agentsDropdown.find(agent => agent.id === selectedAgentFilter)?.username})` : ""}
    //       {selectedAgentFilter !== 0 && (
    //         <CloseCircleOutlined
    //           onClick={handleClearAgent}
    //           style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
    //         />
    //       )}
    //     </span>

    //   ),
    //   dataIndex: "summercamp_agent_names",
    //   key: "summercamp_agent_names",
    //   filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
    //     <div style={{ padding: 8 }}>
    //       <Select
    //         showSearch
    //         placeholder="Select Agent"
    //         style={{ width: 188 }}
    //         value={selectedKeys[0]}
    //         onChange={(value) => {
    //           const selected = agentsDropdown.find((b) => b.username === value);
    //           setSelectedKeys(selected ? [selected.username] : []);
    //           setSelectedAgentFilter(value);
    //           confirm();
    //         }}
    //         allowClear
    //         filterOption={(input, option) =>
    //           typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
    //         }
    //       >
    //         {agentsDropdown.map((branch) => (
    //           <Select.Option key={branch.id} value={branch.id}>
    //             {branch.username}
    //           </Select.Option>
    //         ))}
    //       </Select>
    //     </div>
    //   ),
    //   onFilter: (value: any, record: { branch_name: string }) => record.branch_name === value,
    // },

  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Branch Calling Reports</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Branches
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">

                  <button className="btn btn-primary me-2" onClick={() => fetchSlotsRefresh()}>
                    {refreshIsLoading ? (<i className="spinner-border spinner-border-sm"></i>) : (<>Call Logs Refresh</>)}
                  </button>


                </div>
                {checkPermission("export_scorebranchcallingagentsreports", "scorebranchcallingagentsreports") && (
                  <button className="btn btn-primary me-2" onClick={handleExportClick} >
                    Export
                  </button>
                )}
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div
            className="card "
            style={{
              width: "100%",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              borderRadius: "10px",
            }}
          >
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Branches List</h4>
              <div className="d-flex align-items-center flex-wrap">
                <div style={{ position: "relative", marginRight: "8px", marginBottom: "7px" }}>
                  {/* Date Picker Display Box */}
                  <div
                    onClick={() => setShowCalendar1(!showCalendar1)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "8px 15px",
                      background: "white",
                      borderRadius: "20px",
                      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: "#34303D",
                      cursor: "pointer",
                      border: "1px solid #ddd",
                      minWidth: "200px",
                      justifyContent: "center",
                    }}
                  >
                    {selectedDate ? format(selectedDate, "dd MMM yyyy") : "Choose Monday"}
                  </div>

                  {/* Calendar Popup */}
                  {showCalendar1 && (
                    <div
                      style={{
                        position: "absolute",
                        zIndex: 2000,
                        background: "white",
                        borderRadius: "10px",
                        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                        padding: "5px",
                        left: "-130px",
                        marginTop: "5px",
                      }}
                    >
                      <Calendar
                        date={selectedDate}
                        onChange={(date) => setSelectedDate(date)}
                        color="blue"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* <div
                className="serch-global text-right"
                style={{ marginRight: "15px" }}
              >
                <input
                  type="search"
                  className="form-control form-control-sm mb-3 w-auto float-end"
                  value={searchText}
                  placeholder="Search"
                  onChange={(e) => handleSearch(e.target.value)}
                  aria-controls="DataTables_Table_0"
                ></input>
              </div> */}
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    height: "100vh",
                    paddingTop: "20px",
                  }}
                >
                  <Spin /> {/* Display loader while loading */}
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={admin}
                  Selection={false}
                  pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    locale: { items_per_page: "" },
                    nextIcon: <span>Next</span>,
                    prevIcon: <span>Prev</span>,
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    total: totalCount,
                    showTotal: (total: any, range: any[]) =>
                      `${range[0]}-${range[1]} of ${total}`,
                    pageSizeOptions: ["10", "25", "100", "500", "1000"],
                  }}
                  onChange={handleTableChange} // Move this outside of pagination
                  onSearch={handleSearch}
                  searchText={searchText}
                />
              )}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>


      <>
        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}
      </>
    </div>
  );
};

export default ScoreReports;
